import React, { memo, ReactNode } from 'react';

import { POSITIVE_CHANGE_COLOR, NEGATIVE_CHANGE_COLOR } from './LifeCycleAnalyticsConstants';
import { roundToOneDecimalPlace } from './LifeCycleAnalyticsUtils';
import DeltaArrowIcon from '../icons/DeltaArrowIcon';

const MetricWithDelta = memo(
	({
		value,
		changePercent,
		higherIsBetter,
	}: {
		value: ReactNode;
		changePercent: any;
		higherIsBetter?: boolean;
	}) => {
		const change = parseFloat(changePercent);
		const hasChange = !isNaN(change) && change !== 0;
		const isPositive = change > 0;
		const color = higherIsBetter
			? isPositive
				? NEGATIVE_CHANGE_COLOR
				: POSITIVE_CHANGE_COLOR
			: isPositive
			? POSITIVE_CHANGE_COLOR
			: NEGATIVE_CHANGE_COLOR;
		const arrow = <DeltaArrowIcon direction={isPositive ? 'up' : 'down'} color={color} />;

		return (
			<div className="flex items-center gap-1.5 whitespace-break-spaces">
				<span className="bodyregular text-character-primary">{value}</span>
				<span
					className="footnoteMedium flex items-baseline gap-1 text-character-primary"
					style={hasChange ? { color } : undefined}
				>
					{hasChange && (
						<>
							{arrow} {roundToOneDecimalPlace(Math.abs(change))}%
						</>
					)}
				</span>
			</div>
		);
	}
);
MetricWithDelta.displayName = 'MetricWithDelta';

export default MetricWithDelta;
